import { useEffect, useState } from 'react';
import { Bot, Globe, Play, Users } from 'lucide-react';
import { readSession } from '../hooks/useGameSocket.js';
import { OfflineSaveStore } from '../offline/saveStore.js';
import { TOKEN_LABELS } from '../utils/board.js';

export function MainMenu({ onOnline, onSetup, onContinue, error }) {
  const [localSave, setLocalSave] = useState(null);
  const [saveError, setSaveError] = useState(null);
  const [chooseContinue, setChooseContinue] = useState(false);
  const online = readSession();
  const hasOnline = online && online.status !== 'finished';
  useEffect(() => { new OfflineSaveStore().read().then((save) => setLocalSave(save?.game.status === 'active' ? save : null)).catch((failure) => setSaveError(failure.message)); }, []);
  if (chooseContinue) return <main className="mode-shell"><section className="mode-card">
    <h1>Продолжить игру</h1>
    <div className="mode-buttons">
      <button className="button button--secondary" disabled={!localSave} onClick={() => onContinue('offline')}>Продолжить локальную партию</button>
      <button className="button button--secondary" disabled={!hasOnline} onClick={() => onContinue('online')}>Продолжить онлайн-партию</button>
      <button className="button button--secondary" onClick={() => setChooseContinue(false)}>Назад</button>
    </div>
    {(error || saveError) && <p role="alert">{error || saveError}</p>}
  </section></main>;
  return (
    <main className="mode-shell"><section className="mode-card">
      <div className="brand-lockup brand-lockup--large"><span className="brand-mark" aria-hidden="true"><i /><i /><i /></span><span>Капиталия</span></div>
      <p>Ваш город. Ваши решения.</p>
      <div className="mode-buttons">
        <button className="button button--primary" onClick={onOnline}><Globe size={21} />Играть онлайн</button>
        <button className="button button--secondary" onClick={() => onSetup('bots')}><Bot size={21} />Играть с ботами</button>
        <button className="button button--secondary" onClick={() => onSetup('hotseat')}><Users size={21} />Играть на одном устройстве</button>
        {(localSave || hasOnline) && <button className="button button--secondary" onClick={() => setChooseContinue(true)}><Play size={21} />Продолжить игру</button>}
      </div>
      <small>Боты и игра на одном устройстве работают без интернета.</small>
      {(error || saveError) && <p role="alert">{error || saveError}</p>}
    </section></main>
  );
}

export function OfflineSetup({ mode, onStart, onBack }) {
  const [count, setCount] = useState(mode === 'bots' ? 1 : 2);
  const [players, setPlayers] = useState(() => Object.keys(TOKEN_LABELS).slice(0, 4).map((token, index) => ({ name: `Игрок ${index + 1}`, token })));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const update = (index, field, value) => setPlayers((items) => items.map((item, i) => i === index ? { ...item, [field]: value } : item));
  const start = async (event) => {
    event.preventDefault(); setBusy(true);
    try { await onStart({ mode, players: players.slice(0, mode === 'bots' ? 1 : count), botCount: mode === 'bots' ? count : 0 }); }
    catch (failure) { setError(failure.message); }
    finally { setBusy(false); }
  };
  return <main className="mode-shell"><form className="mode-card" onSubmit={start}>
    <button className="button button--secondary" type="button" onClick={onBack}>Назад</button>
    <h1>{mode === 'bots' ? 'Играть с ботами' : 'На одном устройстве'}</h1>
    <label className="field"><span>{mode === 'bots' ? 'Количество ботов' : 'Количество игроков'}</span><select value={count} onChange={(event) => setCount(Number(event.target.value))}>{(mode === 'bots' ? [1, 2, 3] : [2, 3, 4]).map((value) => <option key={value} value={value}>{mode === 'bots' ? `1 человек + ${value} бот${value === 1 ? '' : 'а'}` : `${value} человека`}</option>)}</select></label>
    {players.slice(0, mode === 'bots' ? 1 : count).map((player, index) => <div className="local-player-fields" key={index}>
      <label className="field"><span>Имя игрока {index + 1}</span><input required maxLength={20} value={player.name} onChange={(event) => update(index, 'name', event.target.value)} /></label>
      <label className="field"><span>Фишка игрока {index + 1}</span><select value={player.token} onChange={(event) => update(index, 'token', event.target.value)}>{Object.entries(TOKEN_LABELS).map(([token, label]) => <option key={token} value={token} disabled={players.slice(0, mode === 'bots' ? 1 : count).some((other, i) => i !== index && other.token === token)}>{label}</option>)}</select></label>
    </div>)}
    {error && <p role="alert">{error}</p>}
    <button className="button button--primary button--wide" disabled={busy}>{busy ? 'Сохраняем…' : 'Начать игру'}</button>
    <p className="privacy-note">Партия автоматически сохраняется на этом устройстве.</p>
  </form></main>;
}
